<div class="content-wrapper" [ngClass]="{'open-aside': isAsideOpen}">
    <div *ngIf="this.isAsideOpen" class="aside-content">
        <div class="aside-head-wrapper">
            <div class="aside-head">
                <h2 class="aside-title">{{title}}</h2>
                <button class="btn btn-hide"
                        *ngIf="isToggleAvailable"
                        (click)="toggleAside(false, $event)">
                    {{closeText}}<em *ngIf="closeChevron" class="md md-chevron-right"></em>
                </button>
            </div>
            <div class="aside-sub-title" *ngIf="subTitle">As of {{subTitle| date: 'EEEE, MMMM d, HH:mm:ss Z y'}}</div>
        </div>

        <ng-content class="aside-content-inner" select="[aside-content]"></ng-content>
    </div>

    <div class="aside-toggle-btn" *ngIf="isToggleButtonExists">
        <button class="btn btn-toggle" (click)="toggleAside(true,$event)">
            <em class="md md-search"></em>
            {{title}}
        </button>
    </div>
</div>
